import React, { useCallback } from "react";

import { DeviceTesterTestState } from "../../../types/Device.types";
import { DeviceTesterActionType } from "../../device-tester-context-provider/Reducer.types";
import { useDeviceTesterDispatchContext } from "../../device-tester-context-provider/DeviceTesterContextProvider";

import { logFinishedSessionAfterAudioTest } from "./ConnectedAudioTestEndedIssue.telemetry";
import { AudioTestEndedIssue } from "./AudioTestEndedIssue";

export const ConnectedAudioTestEndedIssue: React.FC = () => {
  const { deviceTesterDispatch } = useDeviceTesterDispatchContext();

  // Callback to send to the final test completed screen
  const testComplete = useCallback(() => {
    logFinishedSessionAfterAudioTest();
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_DEVICE_TEST_STATE,
      state: DeviceTesterTestState.COMPLETE,
    });
  }, [deviceTesterDispatch]);

  // Callback to run test again
  const runTestAgain = useCallback(() => {
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_DEVICE_TEST_STATE,
      state: DeviceTesterTestState.RESULTS,
    });
  }, [deviceTesterDispatch]);

  return (
    <AudioTestEndedIssue
      completeTest={testComplete}
      runTestAgain={runTestAgain}
    />
  );
};
